<ts-global-device-details>
  <ng-template let-global="global">
    <ts-device-details-options
      [global]="global"
      [carrierChanged$]="global.carrierChanged"
      [load_color_list]="global.load_color_list"
      [load_storage_list_post_check]="global.load_storage_list_post_check"
      [set_name_override_id]="global.set_name_override_id"
      [forward_backward_logic]="global.forward_backward_logic"
      [reset_list_options]="global.reset_list_options"
      (options_disable_btn)="global.disableContinueBtnCheck($event)"
      (storage_list_length)="global.hasStorageList($event)"
    ></ts-device-details-options>
  </ng-template>
</ts-global-device-details>